import { render, staticRenderFns } from "./DiscussSection.vue?vue&type=template&id=5cf5b50e&scoped=true"
import script from "./DiscussSection.vue?vue&type=script&lang=js"
export * from "./DiscussSection.vue?vue&type=script&lang=js"
import style0 from "./DiscussSection.vue?vue&type=style&index=0&id=5cf5b50e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf5b50e",
  null
  
)

export default component.exports